
export default {
    state: {
        aplicacion:[],
        mantenimientos: [],
        home:[],
        vehiculo: {
            dt3: null,
            dt6: null,
            dt7: null
        }
    },

    mutations: {
        setHome(state, formulario) {
            state.home = formulario;
        },
        setVehiculo(state, res) {
            state.vehiculo = res;
        },
        setDescuentos(state, res) {
            state.descuentos = res
        },
        setAplicacion(state, res) {
            state.aplicacion = res
        },
        descuentoAplicado(state, res) {
            state.result = res
        },
        setManteniminetosCotizar(state, mantenimientos) {
            state.mantenimientos = mantenimientos
        },
        setListaBeneficios(state, beneficios) {
            state.beneficios = beneficios
        },
    },

    getters: {
        getHome: state => {
            return state.home;
        },
        getVehiculo: state => {
            return state.vehiculo;
        },
        getDescuentos: state => {
            return state.descuentos
        },
        getAplicacion: state => {
            return state.aplicacion
        },
        getDescuentoAplicado: state => {
            return state.result
        },
        getMantenimientosCotizar: state => {
            return state.mantenimientos
        },
        getListaBeneficios: state => {
            return state.beneficios
        },
    }
}
